import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import "./SearchHeadText.module.css";
export default function SearchHeadText(_ref) {
  var label = _ref.label;
  return /*#__PURE__*/_jsxs("h1", {
    style: {
      textAlign: "center",
      fontSize: "27px"
    },
    children: [/*#__PURE__*/_jsx("span", {
      style: {
        fontWeight: 300
      },
      children: "I am searching for "
    }), /*#__PURE__*/_jsxs("span", {
      style: {
        fontWeight: 500
      },
      children: [" ", label, " "]
    }), /*#__PURE__*/_jsx("span", {
      style: {
        fontWeight: 300
      },
      children: "in"
    })]
  });
}